const menu = (store) => {
  store.on("@init", () => ({ isMenuOpened: false, activeMenu: 0 }));
  store.on("menu/open", (_) => {
    return { isMenuOpened: true };
  });
  store.on("menu/close", (_) => {
    return { isMenuOpened: false, activeMenu: 0 };
  });

  store.on("menu/setActiveMenu", (_, num) => {
    //FIXME: move this custome mobile navbar logic somewhere else
    const isMenuOpened = num !== 98 ? !!num : false;
    return { activeMenu: num, isMenuOpened };
  });
};

export default menu;
